/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Change_DaysInputs */

const en_us2_profile_change_days = /** @type {(inputs: Profile_Change_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change days`)
};

const pt_br2_profile_change_days = /** @type {(inputs: Profile_Change_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudar dias`)
};

const es_419_profile_change_days = /** @type {(inputs: Profile_Change_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar días`)
};

const pt_pt2_profile_change_days = /** @type {(inputs: Profile_Change_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudar dias`)
};

const fr_fr2_profile_change_days = /** @type {(inputs: Profile_Change_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer les jours`)
};

const de_de2_profile_change_days = /** @type {(inputs: Profile_Change_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tage ändern`)
};

const it_it2_profile_change_days = /** @type {(inputs: Profile_Change_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia giorni`)
};

/**
* | output |
* | --- |
* | "Change days" |
*
* @param {Profile_Change_DaysInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_change_days = /** @type {((inputs?: Profile_Change_DaysInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Change_DaysInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_change_days(inputs)
	if (locale === "es-419") return es_419_profile_change_days(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_change_days(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_change_days(inputs)
	if (locale === "de-DE") return de_de2_profile_change_days(inputs)
	if (locale === "it-IT") return it_it2_profile_change_days(inputs)
	return en_us2_profile_change_days(inputs)
});
export { profile_change_days as "profile.change_days" }